import Vue from  "vue";
import signup from "./subscription-signup.vue";
import signupWrapper from './subscription-signup-wrapper.vue';

document.addEventListener("DOMContentLoaded", (e) => {
  document.querySelectorAll("[data-subscription-signup]").forEach(function(el){
    var subscription = el.getAttribute('data-subscription-signup');

    var source = el.attributes["source"].value;

    var optin = el.attributes["optin"] ? el.attributes["optin"].value : "1";

    var flags = el.attributes["flags"];
    if (flags === undefined) {
      flags == "";
    } else {
      flags = flags.value;
    }

    var placeholder = el.attributes["placeholder"];
    if (placeholder === undefined) {
      placeholder = "Sign up for our newsletter";
    } else {
      placeholder = placeholder.value;
    }

    var element = "[data-subscription-signup=" + subscription + "]";

    new Vue({
      el: element,
      data: {flags: flags, source: source, placeholder: placeholder, optin: optin},
      components: { signup },
      template: '<signup :source=source :flags=flags :placeholder=placeholder :optin=optin></signup>'
    });
  });

  document.querySelectorAll("subscription-signup").forEach(function(el){
    var source = el.attributes["source"].value;
    var optin = el.attributes["optin"] ? el.attributes["optin"].value : "1";

    var id = el.attributes["id"];
    if (id === undefined) {
      id == "";
    } else {
      id = id.value;
    }

    var flags = el.attributes["flags"];
    if (flags === undefined) {
      flags == "";
    } else {
      flags = flags.value;
    }

    var placeholder = el.attributes["placeholder"];
    if (placeholder === undefined) {
      placeholder = "Sign up for our newsletter";
    } else {
      placeholder = placeholder.value;
    }

    var message = el.attributes["message"];
    if (message === undefined) {
      message = "";
    } else {
      message = message.value;
    }

    new Vue({
      el: el,
      data: {flags: flags, id: id, source: source, placeholder: placeholder, optin: optin, message: message},
      components: { signupWrapper },
      template: '<signupWrapper :id=id :source=source :flags=flags :placeholder=placeholder :optin=optin :message=message></signupWrapper>'
    });
  });
});
